import LoginForm from "./login.view";
import { useNavigate } from "react-router";
import * as UserServices from "../../../services/UserServices";
import PATHS from "../../../constants/paths";

const LoginContainer = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    try {
      const result = await UserServices.login(values.email, values.password);
      if (result && result.payload.user.requiredChangePassword) {
        navigate(PATHS.CHANGE_PASSWORD, {
          requiredChangePassword: result.payload.user.requiredChangePassword,
        });
      } else {
        navigate(PATHS.SHOW_DATA);
      }
    } catch (error) {}
  };

  return <LoginForm onSubmit={handleSubmit}></LoginForm>;
};

export default LoginContainer;
